import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { mdiFilterOutline } from '@mdi/js'
import filterDashboardModal from '../components/filter.dashboard.modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { computed } from 'vue'
import { filterDashboardStates } from '../components/useFilterDashboard'


export default /*#__PURE__*/_defineComponent({
  __name: 'MoreFilters',
  setup(__props) {

const modalStore = useModalStore()

const hasFilter = computed(() => {
  let isFiltred = false
  Object.values(filterDashboardStates).forEach((v) => {
    if (v) {
      isFiltred = true
    }
  })
  return isFiltred
})
const toggleFilterModal = () => {
  modalStore.toggleModal(EModals.FILTER_STATION)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: _normalizeClass(["filter-btn", hasFilter.value ? 'border border-primary text-primary' : '']),
      onClick: toggleFilterModal
    }, [
      _createVNode(_component_v_icon, {
        size: "small",
        icon: _unref(mdiFilterOutline),
        color: hasFilter.value ? 'primary' : '#808080'
      }, null, 8, ["icon", "color"]),
      _createTextVNode("Filtros ")
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(filterDashboardModal)
    ]))
  ], 64))
}
}

})